import { Checkbox, Grid } from '@mui/material';
import React, { useContext, useState } from 'react'
import GlobalButton from '../../../../../components/utility/globalButton/button';
import globalStyles from "../../../../../assets/styles/global.module.scss"
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import { currentActiveChatbotThreadTypeNew } from '../../../../../models/axiosModel';
import { useShallow } from 'zustand/react/shallow';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
interface SendAgentActivityMsgConfirmationProps {
    getManualOverrideConfig: (thread: currentActiveChatbotThreadTypeNew | null) => any,
    handleToggleManualOverride: (user_assignment_id: string, flag_delete_agent: boolean, flag_send_agent_activity_message: boolean) => void,
}

const SendAgentActivityMsgConfirmation: React.FC<SendAgentActivityMsgConfirmationProps> = (props) => {
    
    const { getManualOverrideConfig, handleToggleManualOverride } = props;
    const { userDetail } = useContext(UserContext) as UserContextPayload;

    const [flagSendMsg, setFlagSendMsg] = useState<boolean>(true);

    const { selectedAgentId, currentActiveChatbotThread, setFlagSendAgentActivityMsgConfirmation } = useRuleBasedInboxStore(
        useShallow((state) => ({
            selectedAgentId: state.selectedAgentId,
            currentActiveChatbotThread: state.currentActiveChatbotThread,
            setFlagSendAgentActivityMsgConfirmation: state.setFlagSendAgentActivityMsgConfirmation,
        }))
    )

    const getBtnText = () => {
        if(currentActiveChatbotThread){
            if(getManualOverrideConfig(currentActiveChatbotThread)?.toLowerCase() == 'takeover'){
                if(currentActiveChatbotThread?.manual_agent_data?.length > 0){
                    return 'Leave';
                }
            }

            return getManualOverrideConfig(currentActiveChatbotThread);
        }
        return '';
    }
    
    return (
        <>
            <Grid container className={globalStyles.flexColumn}  >
                <Grid item xs={12} className={globalStyles.deleteConfirmHeaderPopup}>
                    <Grid container >
                        <Grid item className={globalStyles.deleteConfirmPopupStyle}>
                            <TaskAltIcon className={`${styles.sendMsgConfirmationIcon}`} />
                        </Grid>
                        <Grid item >
                            <Grid container className={globalStyles.flexColumn}>
                                <Grid item className={globalStyles.deleteConfirmPopupTextStyle}>
                                    Send Message Confirmation
                                </Grid>
                                <Grid item className={globalStyles.deleteConfirmPopupSubTextStyle}>
                                    <Grid container className={globalStyles.contentCenter} >
                                        <Grid item>
                                            <Checkbox
                                                className={styles.sendAgentActivityConfirmationCheckbox} 
                                                disableRipple 
                                                checked={flagSendMsg}
                                                onChange={(event) => { setFlagSendMsg(event.target.checked) }} 
                                            />
                                        </Grid>
                                        <Grid item className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontSize} ${globalStyles.displayFlex}`}>
                                            Send Agent Activity Message
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={`${globalStyles.deleteConfirmButtonsPopup} ${globalStyles.fullwidth} ${globalStyles.textItemsEnd}`}>
                    <GlobalButton
                        buttonText={getBtnText()} 
                        sx={{width: "110px !important"}} 
                        flagFullWidth 
                        className='primaryButtonStyle'
                        onClick={() => {
                            setFlagSendAgentActivityMsgConfirmation(false);
                            handleToggleManualOverride(selectedAgentId ?? String(userDetail.user_assignment_id), getBtnText() == "Leave", flagSendMsg)
                        }}
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default SendAgentActivityMsgConfirmation
